import React from 'react'
import { Link } from 'react-router-dom'
import Translation from '../General/Translation'

const BackToOverview = ({translation, pathname}) => (
    <div className="grid-site-wrapper overview-back-link-wrapper">
        <Link className="overview-back-link" to={{pathname: '/' + pathname, search: null}}>
            <span className="overview-back-link-text text-light button">
                <Translation id="backToprogramOverview" trans={translation}>Zur Programmübersicht</Translation>
            </span>
        </Link>
    </div>
)

export default BackToOverview